function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.5 2.5c-.1 0-.2-.1-.3-.1-.2 0-.3.1-.5.2-.2.2-.3.5-.1.8C20.5 5.1 21 7 21 8.9c0 6.5-5.3 11.9-11.9 11.9-1.9 0-3.8-.5-5.5-1.4-.1 0-.2-.1-.3-.1-.2 0-.3.1-.5.2-.2.2-.3.5-.1.8 2.3 4.3 6.8 7.1 11.7 7.1 7.3 0 13.2-5.9 13.2-13.2-.1-4.9-2.8-9.4-7.1-11.7zM14.3 26c-3.3 0-6.5-1.4-8.8-3.9l-.5-.5.7.2c1.1.3 2.2.4 3.4.4 7.3 0 13.2-5.9 13.2-13.2 0-1.1-.2-2.3-.4-3.4l-.2-.7.5.5c2.5 2.2 3.9 5.5 3.9 8.8 0 6.5-5.3 11.8-11.8 11.8z"
})));